<template>
    <div class="ma-login">
        <el-dialog :visible.sync="dialogVisible" :show-close="false" :append-to-body="true" :top="dialogTopMargin" :close-on-click-modal="false" custom-class="ma-login__dialog">
            <div class="ma-login__content">
                <h1 class="ma-login__title h2">Mitarbeiter:innen-Login</h1>
                <div class="ma-login__text copy">Bitte loggen Sie sich mit Ihren Mitarbeiter:innen-Daten ein, um alle spezifischen Funktionen nutzen zu können.</div>
                <div class="ma-login__form form">
                    <div class="form__fields">
                        <div class="form__field-row">
                            <SmrInput
                                :value="data.username"
                                placeholder="Mitarbeiter:innennummer"
                                @change="fieldChangeHandler($event, 'username')">
                            </SmrInput>
                        </div>
                        <div class="form__field-row">
                            <SmrInput
                                :value="data.password"
                                placeholder="Passwort"
                                inputType="password"
                                @change="fieldChangeHandler($event, 'password')"
                            >
                            </SmrInput>
                        </div>
                        <div class="form__field-row">
                            <SmrButton size="medium" :icon="true" :iconRight="true" @click.native="loginClickHandler" :loading="loading">
                                Anmelden
                                <Icon slot="icon"><IconArrowRight /></Icon>
                            </SmrButton>
                        </div>
                        <div class="form__field-row" v-if="showError">
                           <div class="copy red">Beim Login ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre Daten.</div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eventBus from '@/utils/event-bus';
import SmrInput from '@/components/form/SmrInput.vue'
import SmrButton from '@/components/SmrButton.vue'
import Icon from '@/components/Icon.vue'
import IconArrowRight from '@/components/icons/IconArrowRight.vue';

export default {
    components: {
        SmrInput,
        SmrButton,
        Icon,
        IconArrowRight
    },
    data() {
        return {
            dialogVisible: false,
            showError: false,
            loading: false,
            data: {
                username: '',
                password: '',
            }
        }
    },
    computed: {
        ...mapGetters(['mobile', 'sessionData']),
        dialogTopMargin() {
            return '25%';
        }
    },
    created() {
        this.addListeners()
    },
    beforeDestroy() {
        this.removeListeners()
    },
    methods: {
        fieldChangeHandler(output, dataKey) {
            this.data[dataKey] = output;
        },
        closeClickHandler() {
            this.closeDialog();
        },
        showMALoginOverlayHandler() {
            this.showDialog()
        },
        async loginClickHandler() {
            if(this.loading) return
            this.showError = false
            this.loading = true
            try {
                const response = await this.$store.dispatch('loginWithPassword', {...this.data})
                if(response) {
                    this.closeDialog();
                } else {
                    this.showError = true
                }
                this.loading = false
            } catch(error) {
                console.error(error)
                this.loading = false
            }
        },
        addListeners() {
            eventBus.$on('showMALoginOverlay', this.showMALoginOverlayHandler);
        },
        removeListeners() {
            eventBus.$off('showMALoginOverlay', this.showMALoginOverlayHandler);
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        showDialog() {
            this.dialogVisible = true;
        },
    }
}
</script>

<style lang="scss">
.ma-login {
    &__dialog {
        border-radius: $standard-border-radius;
        max-width: 500px !important;
        width: calc(100% - 32px);

        .el-dialog {
            &__header {
                display: none;
            }
            &__body {
                position: relative;
                padding: 0;
                color: black;
            }
        }
    }

    &__inner {
        position: relative;
        max-height: calc(#{$fullheight} - 128px);
        overflow: hidden;
        display: flex;
        flex-direction: column;

        @include mq($until: tablet) {
            max-height: calc(#{$fullheight} - 64px);
        }

        &:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 30px;
            width: 100%;
            background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
            border-radius: $standard-border-radius;
        }
    }

    &__content {
        padding: 30px 30px 24px;
        overflow: auto;
        word-break: initial;
    }

    &__title {
        margin-bottom: 4px !important;
    }

    &__text {
        margin-bottom: 24px;
        word-break: normal;
    }
}
</style>